import { Map, fromJS } from 'immutable';
import React from 'react';
import { Panel, Col } from 'react-bootstrap';
import numeral from 'numeral';
import { formatCurrency as formatCurrencyString } from '../../../../util/util';

export default function BaseElement(props) {
  return (
    props.col ?
      <div style={{ width: '100%' }}>
        <Col xs={props.col} id={props.id}>
          <Panel style={{ paddingLeft: 5, paddingRight: 5 }} >
            <span>
              {props.children}
            </span>
          </Panel>
        </Col>
        <Col xs={12 - props.col} />
      </div>
      :
      <Panel style={{ paddingLeft: 5, paddingRight: 5 }} id={props.id}>
        <span>
          {props.children}
        </span>
      </Panel>
  );
}

BaseElement.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node,
  ]),
  col: React.PropTypes.number,
  id: React.PropTypes.string,
};

export const formatNumber = (number, numberFormat = '0,0') =>
  (number == undefined || number == null || number == '' ?
    '' : numeral(number).format(numberFormat)) || 0;
export const formatNumberZeroIfNull = (number, numberFormat = '0,0') =>
  (number == undefined || number == null || number == '' ?
    numeral(0).format(numberFormat) : numeral(number).format(numberFormat));


export const formatCurrency = (currencyString) => formatCurrencyString(currencyString);

export const formatRange = (firstDate, secondDate) => {
  if (!firstDate) {
    return secondDate;
  } else if (!secondDate) {
    return firstDate;
  } else if (firstDate === secondDate) {
    return firstDate;
  }

  const firstDateAsArray = firstDate.split(' ');
  const secondOneAsArray = secondDate.split(' ');
  let result = '';
  let i;
  for (i = 2; i >= 0; --i) {
    if (firstDateAsArray[i] === secondOneAsArray[i]) {
      result = `${firstDateAsArray[i]} ${result}`;
    } else {
      break;
    }
  }

  return (`${firstDateAsArray.slice(0, i + 1).join(' ')} - ` +
  `${secondOneAsArray.slice(0, i + 1).join(' ')} ${result}`).trim();
};

function extractContractAbbrev(value) {
  let abbrev = '';
  if (value) {
    const data = value.split('_');
    data.forEach((segment) => {
      abbrev += segment.toUpperCase()[0];
    });
  }
  return abbrev;
}

export const formatQuantity = (dataArg = new Map(), isShort, withContractOption = true) => {
  const data = !dataArg || dataArg.get ? dataArg : fromJS(dataArg);
  let resultFixed = '';
  const toNumFloat = (n) => numeral(parseFloat(n)).format('0,0.[000]');
  const abbrev = withContractOption ? extractContractAbbrev(data.get('contractOption')) : '';
  const quantity = data.get('quantity');
  const quantityMinP = data.get('quantityMinP');
  const quantityMaxP = data.get('quantityMaxP');
  let result = [];
  if (quantity && quantity !== '0') {
    result.push(`${toNumFloat(quantity)}`);
    if (quantityMinP
        && quantityMaxP
        && quantityMinP === quantityMaxP
        && parseInt(quantityMinP, 10) !== 0
        && parseInt(quantityMaxP, 10) !== 0) {
      result = [];
      result.push(`${toNumFloat(quantity)} ±${quantityMinP}% ${abbrev}`);
    } else {
      let tempresult = '';
      if (quantityMinP && parseInt(quantityMinP, 10) !== 0) {
        tempresult = `-${quantityMinP}%`;
        if (!quantityMaxP) {
          tempresult = `${tempresult} ${abbrev}`;
        }
      }
      if (quantityMaxP && parseInt(quantityMaxP, 10) !== 0) {
        tempresult = `${tempresult} +${quantityMaxP}% ${abbrev}`;
      }
      result = [];
      result.push(`${toNumFloat(quantity)} ${tempresult}`);
    }
  } else {
    const quantityMin = data.get('quantityMin');
    const quantityMax = data.get('quantityMax');
    if (quantityMin) {
      resultFixed = toNumFloat(quantityMin);
    }
    if (quantityMax) {
      resultFixed = `${resultFixed || 0} - ${toNumFloat(quantityMax)}`;
    }
    if (quantityMin !== quantityMax && !quantityMinP && !quantityMaxP) {
      resultFixed = `${resultFixed} ${abbrev}`;
    }
    if (result.length > 0) {
      result.push(`(${resultFixed})`);
    } else {
      result.push(`${resultFixed}`);
    }
  }

  const leftStyle = { color: 'darkgrey', fontSize: '12px' };
  const rightStyle = {};
  return (<span name="quantity">
    {result.map((x, i) => (i == 1 ?
      <span key={i} style={leftStyle}> {x}
        {isShort ? ' ' : <br />}</span> :
      <span key={i} style={rightStyle}>{x} {isShort ? ' ' : <br />}</span>))}
  </span>);
};

export const BOLD_FONT = {
  fontWeight: 'bold',
};

export function calculateUnlinkedObject(data, linksProvided) {
  if (data) {
    if (data.get('completedLink')) {
      return { quantityMin: 0, quantityMax: 0 };
    }
    let quantityMin = data.get('quantityMin');
    let quantityMax = data.get('quantityMax');

    if (quantityMax || quantityMin) {
      if (data.get('shrinkageIsPercentage')) {
        const shrinkageMin = data.get('shrinkagePercent', 0) / 100 * quantityMin;
        const shrinkageMax = data.get('shrinkagePercent', 0) / 100 * quantityMax;
        quantityMin -= shrinkageMin;
        quantityMax -= shrinkageMax;
      } else {
        const shrinkage = data.get('shrinkage', 0);
        quantityMin -= shrinkage;
        quantityMax -= shrinkage;
      }
      let links = linksProvided;
      if (!linksProvided) {
        if (data.get('purchaseLink') && data.get('purchaseLink').size > 0) {
          links = data.get('purchaseLink');
        } else if (data.get('saleLink') && data.get('saleLink').size > 0) {
          links = data.get('saleLink');
        }
      }
      let sumMin = 0;
      let sumMax = 0;
      if ((quantityMin || quantityMax) && links) {
        links.forEach((e) => {
          if (!e.get('hidden')) {
            if (e.get('billLandingQuantity')) {
              const blq = e.get('billLandingQuantity') ?
                Number.parseFloat(e.get('billLandingQuantity')) : 0.0;
              sumMin += blq;
              sumMax += blq;
            } else {
              sumMin += e.get('quantityMin') ? Number.parseFloat(e.get('quantityMin')) : 0.0;
              sumMax += e.get('quantityMax') ? Number.parseFloat(e.get('quantityMax')) : 0.0;
            }
          }
        });
      }
      quantityMin -= sumMax.toFixed(3);
      quantityMax -= sumMin.toFixed(3);
      quantityMin = quantityMin < 0 ? 0 : quantityMin;
      quantityMax = quantityMax < 0 ? 0 : quantityMax;
      return { quantityMin, quantityMax };
    }
  }
  return {};
}

export function formatUnlinkedString(data, format = '0,0.[000]') {
  if (data) {
    const quantityMin = parseFloat(!data.quantityMin || data.quantityMin < 0
      ? 0
      : data.quantityMin.toFixed(2));
    const quantityMax = parseFloat(!data.quantityMax || data.quantityMax < 0
      ? 0
      : data.quantityMax.toFixed(2));
    if (quantityMin === quantityMax) {
      return ` ${numeral(quantityMin).format(format)}`;
    }
    return ` ${numeral(quantityMin).format(format)
    } - ${numeral(quantityMax).format(format)}`;
  }
  return '';
}
export function formatUnlinkedStringThousand(data) {
  return formatUnlinkedString(data, '0.[0]a');
}
export function calculateUnlinked(data, linksProvided) {
  if (data) {
    const unlinked = calculateUnlinkedObject(data, linksProvided);
    return formatUnlinkedString(unlinked);
  }
  return '';
}


export function getStatus(data) {
  if (data) {
    if (data.get('agreedVerbally')) {
      return 'Agreed verbally';
    }
    if (data.get('agreedInWriting')) {
      return 'Agreed in writing';
    } if (data.get('contactSent')) {
      return 'Contract sent';
    } if (data.get('contactReceived')) {
      return 'Contract received';
    } if (data.get('contactSigned')) {
      return 'Contract signed';
    }
  } return '';
}
export const formatProductLabel = (productTypeLabel, packingLabel) => (
  <span
    style={{ display: 'inline-block', wordBreak: 'break-all', whiteSpace: 'normal' }}
  >
    {productTypeLabel}{packingLabel ? ' in' : ''} {packingLabel}
  </span>);
